import { UIWManagerEvents } from './UIWManagerEvents.ts';
import { DiscordInstance } from '../discord/DiscordInstance.ts';
import { SDKRequest } from '../../../../shared/DiscordActivityTypes.ts';
import { SocketLobbySend } from '../../../shared/scripts/socket/SocketLobbySend.ts';
import { Scene } from './UISceneTypes.ts';
import { ColonistMembershipType } from '@colonist/types';
import { UIDSubscriptionOverlayController } from '../store/subscription_overlay/UIDSubscriptionOverlayController.ts';
export class UIDManagerEvents extends UIWManagerEvents {
    leaveRoomAndJoinRoom(roomId) {
        var _this_uiManager, _this_uiManager1;
        if (((_this_uiManager = this.uiManager) === null || _this_uiManager === void 0 ? void 0 : _this_uiManager.sceneController.scene) == Scene.Room) (_this_uiManager1 = this.uiManager) === null || _this_uiManager1 === void 0 ? void 0 : _this_uiManager1.room.resetRoom();
        void SocketLobbySend.clickedJoinRoom(roomId);
    }
    performRoomLeavingAction(action) {
        var _this_uiManager;
        if (((_this_uiManager = this.uiManager) === null || _this_uiManager === void 0 ? void 0 : _this_uiManager.sceneController.scene) == Scene.Room) {
            var _this_uiManager1;
            (_this_uiManager1 = this.uiManager) === null || _this_uiManager1 === void 0 ? void 0 : _this_uiManager1.room.confirmLeaveRoom(action);
            return;
        }
        action();
    }
    premiumMembershipCheckAction() {
        if (this.showSubscriptionOverlayIfVariant()) return;
        void DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.PurchaseMembership, ColonistMembershipType.PremiumMonthly);
    }
    // eslint-disable-next-line class-methods-use-this
    createSubscriptionOverlayController() {
        return new UIDSubscriptionOverlayController();
    }
    // eslint-disable-next-line class-methods-use-this
    shareImage(title, text, link, imageFile, imageSrc) {
        void DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.ShareMoment, imageFile);
    }
}
